import api from './Axios';

/**
 * Departments API
 * Base: /api/departments
 */

export const createDepartment = (data) =>
  api.post('/departments', data);

export const getDepartments = () =>
  api.get('/departments');

export const getDepartmentById = (departmentId) =>
  api.get(`/departments/${departmentId}`);

export const updateDepartment = (departmentId, data) =>
  api.put(`/departments/${departmentId}`, data);

export const addMember = (departmentId, data) =>
  api.post(`/departments/${departmentId}/members`, data);

export const removeMember = (departmentId, userId) =>
  api.delete(`/departments/${departmentId}/members/${userId}`);

export const addActivity = (departmentId, data) =>
  api.post(`/departments/${departmentId}/activities`, data);